<footer class="footer-login">
  <p [innerHTML]="copyright" class="footer-login__copyright"></p>
  <a
    [core-analytics]="{ action: 'Cookie policy', category: 'LOGIN' }"
    class="CookieReportsLink footer-login__cookie-policy"
    href="//policy.cookiereports.com/a57e434e-en-gb.html">
    <small>{{ 'Cookie Policy' | translate }}</small>
  </a>
</footer>
